'use client';
import Section from '@repo/ui/src/components/Section';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import {
  AmplienceButtonProps,
  HeaderVariationProps,
  MetaProps,
  MediaType,
} from '@repo/ui/src/types';
import { classNames } from '@repo/ui/src/utils/classNames';
import { appConfig } from '../../utils/appConfig';

export interface SeriesTitleProps {
  lilHeading?: string;
  lilHeaderVariation?: HeaderVariationProps;
  heading: string;
  headerVariation: HeaderVariationProps;
  description?: string;
  showDivider: boolean;
  useTexture: boolean;
  align?: 'left' | 'right' | 'center';
  whiteBackground: boolean;
  blackBackground: boolean;
  brandBackground?: boolean;
  includeBottomPadding: boolean;
  darkMode: boolean;
  _meta?: MetaProps;
  button?: Array<AmplienceButtonProps>;
  icon?: MediaType;
}

const SeriesTitleAndText = ({
  lilHeading,
  lilHeaderVariation,
  heading,
  headerVariation,
  description,
  showDivider,
  useTexture,
  align,
  whiteBackground,
  darkMode,
  blackBackground,
  brandBackground,
  includeBottomPadding,
  button,
  icon,
}: SeriesTitleProps) => {
  return (
    <div>
      <Section
        gutterX
        gutterY={includeBottomPadding}
        white={whiteBackground}
        black={blackBackground}
        texture={useTexture}
        dark={darkMode}
        brandBackground={brandBackground}
        className={classNames(!includeBottomPadding && 'pb-2 pt-[3.332vw]')}
      >
        <ToutContent
          align={align}
          heading={heading}
          headerVariation={headerVariation}
          headingStyleVariant={headerVariation?.headerVariation ?? 'h2'}
          lilHeading={lilHeading}
          lilHeaderVariation={lilHeaderVariation}
          description={description}
          forceDivider={showDivider}
          brandBackground={brandBackground}
          fullWidth
          flexible
          dark={darkMode || blackBackground || brandBackground}
          icon={icon}
          buttons={button}
          buttonNegative={appConfig.isMeater && darkMode}
          className={classNames(
            button && 'mb-6',
            appConfig.isMeater && darkMode && '[&_.divider]:bg-black',
          )}
        />
      </Section>
    </div>
  );
};

export default SeriesTitleAndText;
